var _rect, _mask, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPrescribedMedication(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 356,
    height: 145,
    viewBox: "0 0 356 145",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 356,
    height: 145,
    fill: "#F6F6F6"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 356,
    height: 145
  }, /*#__PURE__*/React.createElement("rect", {
    width: 356,
    height: 145,
    fill: "#C4C4C4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35 89.755V99.0028C35 100.11 34.109 101.001 33.0019 101.001H22.9981C21.891 101.001 21 100.11 21 99.0028V89.755C21 86.0559 22.377 82.4782 24.8476 79.7241L25.4957 78.9951H30.4908L31.1389 79.7106C33.623 82.4782 35 86.0559 35 89.755Z",
    fill: "#00A9E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35 89.7551V92.9952H21V89.7551C21 87.784 21.3915 85.8265 22.1475 84.0039H33.8525C34.6085 85.8265 35 87.784 35 89.7551Z",
    fill: "#002F6C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.5043 87.5005H29.0057V86.002H26.9942V87.5005H25.4956V89.4986H26.9942V90.9971H28.9922V89.4986H30.4908V87.5005H30.5043Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.5033 76.9971V74.999C31.5033 74.4455 31.0578 74 30.5043 74H25.5091C24.9421 74 24.4966 74.4455 24.4966 74.999V76.9971H31.5033Z",
    fill: "#002F6C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.4956 76.9971H30.4908V78.9951H25.4956V76.9971Z",
    fill: "#00A9E0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 16,
    r: 27.5,
    fill: "white",
    stroke: "#ED7B90",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 -5.2666L17.9 21.8001H12.1L15 -5.2666Z",
    fill: "#ED7B90"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.8273 33.1778L12.0992 21.8002L17.4161 18.9002L27.8273 33.1778Z",
    fill: "#ED7B90"
  }), /*#__PURE__*/React.createElement("rect", {
    y: 101,
    width: 356,
    height: 16,
    fill: "#E4E4E4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 117,
    width: 321,
    height: 28,
    fill: "#D7D7D7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.548 12.0919C273.548 12.0919 263.402 15.7318 266.699 26.56C269.997 37.3883 260.444 45.6834 265.517 47.4602C270.59 49.237 306.947 53.8922 304.918 43.1452C302.889 32.3981 293.164 -1.27978 273.548 12.0919Z",
    fill: "#364851"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.714 40.232C281.371 35.1934 268.664 42.7513 268.664 42.7513C258.36 49.0447 249.89 67.9346 249.89 71.7136C249.89 75.4925 256.758 76.6363 260.995 76.4095C262.593 76.3226 264.016 78.6296 264.026 82.9587C264.04 88.0858 262.824 96.5976 262.136 101H308.49C308.184 94.7622 307.417 80.0638 306.791 75.951C305.99 70.6856 314.576 73.8902 317.438 72.4037C320.3 70.9172 312.057 45.2706 296.714 40.232Z",
    fill: "#E57200"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.106 16.4937C273.106 16.4937 265.49 34.5102 279.224 36.4982C279.224 36.4982 282.595 36.0409 276.352 42.5865C270.11 49.132 290.086 48.7145 291 39.1919C291 39.1919 285.671 31.9456 287.964 29.2916C290.256 26.6376 289.836 20.6338 285.881 23.0791C281.926 25.5243 284.218 21.1308 283.883 20.3455C283.554 19.5603 275.728 11.812 273.106 16.4937Z",
    fill: "#FFB59E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.778 72.862C315.778 72.862 321.733 104.623 304.098 91.6457C286.463 78.668 293.871 74.9325 283.645 75.3137C273.418 75.695 281.738 68.5956 283.341 68.0647C284.861 67.558 289.523 66.8437 292.197 68.7501C292.901 69.252 294.248 70.7529 295.575 72.3166C303.302 81.4189 306.193 81.1921 306.7 78.6728C306.984 77.2635 306.637 76.0763 306.651 74.807C306.661 73.75 307.679 73.1902 308.625 72.9489C310.966 72.3456 314.431 72.4904 315.778 72.862Z",
    fill: "#FFB59E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.316 79.8453H263.635C262.433 79.8453 261.454 78.8704 261.454 77.6639L254.127 48.2142C254.127 47.0124 255.102 46.0327 256.309 46.0327H275.99C277.192 46.0327 278.172 47.0076 278.172 48.2142L285.498 77.6639C285.493 78.8656 284.518 79.8453 283.316 79.8453Z",
    fill: "#172757"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.918 73.8899C250.918 73.8899 242.79 104.117 253.664 97.244C264.542 90.3763 259.731 81.7856 263.852 79.1553C267.974 76.5202 275.99 66.6746 268.432 69.4256C260.874 72.1717 259.504 70.9121 259.272 69.1988C259.045 67.4806 258.128 65.7625 258.012 69.7731C257.897 73.7789 257.438 73.8947 257.211 75.0385C256.984 76.1823 250.918 73.8899 250.918 73.8899Z",
    fill: "#FFB59E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.775 104.525L228.866 106.494L202.875 101.306L234.993 100.823L255.775 104.525Z",
    fill: "#364851"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.733 106.468L228.824 108.174L228.829 106.489L255.754 104.525L255.733 106.468Z",
    fill: "#364851"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.212 107.828L198.055 102.577C197.141 102.577 196.401 101.837 196.401 100.923L188 74.654C188 73.7403 188.74 73 189.654 73L217.761 74.5752C218.674 74.5752 219.415 75.3155 219.415 76.2292L228.866 106.174C228.866 107.087 228.125 107.828 227.212 107.828Z",
    fill: "#A09F9F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.845 108.179L196.401 102.304L196.412 100.913L228.824 106.468L228.845 108.179Z",
    fill: "#364851"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M172.257 72.1501C177.208 65.6263 180.057 57.9059 180.022 49.6416C179.921 26.4003 157.042 7.65804 128.92 7.77966C100.798 7.90127 78.0815 26.8407 78.182 50.082C78.2825 73.3233 101.162 92.0656 129.284 91.944C140.672 91.8947 151.174 88.7596 159.633 83.5025L159.361 83.7875C164.442 91.4862 178.877 87.2963 183.249 84.2757C171.433 81.488 171.009 76.1502 172.257 72.1501Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.022 49.6416L179.522 49.6438L180.022 49.6416ZM172.257 72.1501L171.858 71.8478L171.805 71.9176L171.779 72.0012L172.257 72.1501ZM128.92 7.77966L128.918 7.27966L128.92 7.77966ZM78.182 50.082L77.682 50.0842L78.182 50.082ZM129.284 91.944L129.286 92.444L129.284 91.944ZM159.633 83.5025L159.995 83.8474L159.369 83.0778L159.633 83.5025ZM159.361 83.7875L158.999 83.4426L158.725 83.7307L158.944 84.0629L159.361 83.7875ZM183.249 84.2757L183.533 84.6871L184.459 84.0475L183.364 83.7891L183.249 84.2757ZM179.522 49.6438C179.557 57.7877 176.75 65.4028 171.858 71.8478L172.655 72.4524C177.666 65.8498 180.558 58.0242 180.522 49.6395L179.522 49.6438ZM128.922 8.27965C156.861 8.15883 179.423 26.7635 179.522 49.6438L180.522 49.6395C180.42 26.037 157.223 7.15726 128.918 7.27966L128.922 8.27965ZM78.682 50.0798C78.5831 27.1996 100.983 8.40047 128.922 8.27965L128.918 7.27966C100.613 7.40206 77.58 26.4817 77.682 50.0842L78.682 50.0798ZM129.282 91.444C101.342 91.5648 78.781 72.9601 78.682 50.0798L77.682 50.0842C77.7841 73.6866 100.981 92.5664 129.286 92.444L129.282 91.444ZM159.369 83.0778C150.991 88.2846 140.58 91.3951 129.282 91.444L129.286 92.444C140.764 92.3943 151.357 89.2346 159.897 83.9272L159.369 83.0778ZM159.271 83.1576L158.999 83.4426L159.723 84.1324L159.995 83.8474L159.271 83.1576ZM158.944 84.0629C161.643 88.1534 166.777 89.0167 171.619 88.549C176.478 88.0797 181.265 86.2541 183.533 84.6871L182.965 83.8644C180.861 85.3179 176.244 87.0976 171.523 87.5537C166.783 88.0115 162.16 87.1203 159.778 83.5121L158.944 84.0629ZM183.364 83.7891C177.506 82.4071 174.596 80.4192 173.272 78.3939C171.961 76.3882 172.132 74.2292 172.734 72.299L171.779 72.0012C171.134 74.0711 170.893 76.581 172.435 78.9411C173.966 81.2818 177.176 83.3566 183.134 84.7624L183.364 83.7891Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.998,
    d: "M161.367 50.6504C163.56 50.6504 165.664 51.5199 167.217 53.0683C168.766 54.6213 169.636 56.7253 169.636 58.9189C169.636 61.1124 168.766 63.2165 167.217 64.7695L156.186 75.8006C154.634 77.3521 152.53 78.2236 150.335 78.2235C148.141 78.2234 146.037 77.3516 144.485 75.7999C142.934 74.2482 142.062 72.1438 142.062 69.9495C142.063 67.7552 142.934 65.6508 144.486 64.0994L155.517 53.0683C157.07 51.5199 159.174 50.6504 161.367 50.6504Z",
    fill: "#E57200"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.998,
    d: "M161.372 50.6504C163.565 50.6504 165.669 51.5199 167.222 53.0683C168.771 54.6213 169.641 56.7253 169.641 58.9189C169.641 61.1124 168.771 63.2165 167.222 64.7695L161.706 70.285L150.007 58.5838L155.522 53.0683C157.075 51.5199 159.179 50.6504 161.372 50.6504Z",
    fill: "#E61F50"
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: 11.9961,
    ry: 12.7175,
    transform: "matrix(-0.884567 0.45928 0.4667 0.867869 147.315 51.6272)",
    fill: "#80D4EF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.923 44.1547L136.64 55.3637L138.241 58.5663L158.435 46.9939L156.923 44.1547Z",
    fill: "#00A9E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.228 77.7816H102.432C102.164 77.7816 101.945 77.5599 101.945 77.2889V20.628C101.945 20.357 102.164 20.1353 102.432 20.1353H145.228C145.495 20.1353 145.714 20.357 145.714 20.628V77.2889C145.714 77.5599 145.495 77.7816 145.228 77.7816Z",
    fill: "#223367"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.869 75.6463H105.791C104.846 75.6463 104.08 74.866 104.08 73.9035V24.0128C104.08 23.0502 104.846 22.27 105.791 22.27H141.869C142.813 22.27 143.579 23.0502 143.579 24.0128V73.9035C143.579 74.866 142.813 75.6463 141.869 75.6463Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.847 23.3376H117.745C116.094 23.3376 114.756 22.143 114.756 20.6688C114.756 19.1946 116.094 18 117.745 18H128.847C130.498 18 131.836 19.1946 131.836 20.6688C131.836 22.143 130.498 23.3376 128.847 23.3376Z",
    fill: "#6C7A9E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.633 75.6465H141.918C142.836 75.6465 143.579 74.8899 143.579 73.9546V53.2285C142.928 74.4528 128.633 75.6465 128.633 75.6465Z",
    fill: "#A09F9F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.033 69.1843C130.033 69.1843 131.955 75.6465 128.633 75.6465C128.633 75.6465 142.928 74.4528 143.579 53.2285C143.265 56.2364 141.229 62.9735 130.033 69.1843Z",
    fill: "#E4E4E4"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 123.296,
    cy: 35.0806,
    r: 7.47267,
    fill: "#E57200"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 122.228,
    y: 30.8105,
    width: 2.13505,
    height: 8.5402,
    rx: 1.06752,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 127.566,
    y: 34.0132,
    width: 2.13505,
    height: 8.5402,
    rx: 1.06752,
    transform: "rotate(90 127.566 34.0132)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 110.486,
    y: 46.8232,
    width: 26.6881,
    height: 2.13505,
    rx: 1.06752,
    fill: "#6C7A9E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 110.486,
    y: 52.1606,
    width: 26.6881,
    height: 2.13505,
    rx: 1.06752,
    fill: "#6C7A9E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 110.486,
    y: 57.4985,
    width: 26.6881,
    height: 2.13505,
    rx: 1.06752,
    fill: "#6C7A9E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 110.486,
    y: 62.8359,
    width: 14.9453,
    height: 2.13505,
    rx: 1.06752,
    fill: "#6C7A9E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.085 58.9263L97.1918 61.8196L107.403 72.0313L110.297 69.1379L100.085 58.9263Z",
    fill: "#00A9E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.405 72.0349L110.299 69.1411L111.355 72.727C111.421 72.9497 111.214 73.1567 110.991 73.0911L107.405 72.0349Z",
    fill: "#002F6C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.8053 52.9298L91.1934 50.5417C91.333 50.4021 91.5594 50.4021 91.6991 50.5417L100.086 58.9282L97.1918 61.822L88.8053 53.4356C88.6657 53.2959 88.6657 53.0695 88.8053 52.9298Z",
    fill: "#002F6C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.9247 52.8102L91.0741 50.6609L89.657 49.2438C89.2759 48.8627 88.658 48.8627 88.2768 49.2438L87.5077 50.013C87.1266 50.3941 87.1266 51.012 87.5077 51.3931L88.9247 52.8102Z",
    fill: "#00A9E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.195 58.1844C101.289 58.1844 101.383 58.1486 101.454 58.0771C101.598 57.9339 101.598 57.7019 101.454 57.5587L95.0909 51.1952C94.9477 51.0521 94.7157 51.0521 94.5726 51.1952C94.4294 51.3384 94.4294 51.5704 94.5726 51.7135L100.936 58.0771C101.008 58.1486 101.102 58.1844 101.195 58.1844Z",
    fill: "#00A9E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.9446 54.9935L93.8204 51.1177C94.0066 50.9315 94.3085 50.9315 94.4947 51.1177L95.5061 52.1291L91.2931 56.342C91.1023 56.5328 90.7929 56.5328 90.6021 56.342L89.9446 55.6845C89.7538 55.4937 89.7538 55.1843 89.9446 54.9935Z",
    fill: "#5A5A5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.9445 54.9935L94.0698 50.8683C94.2613 50.6767 94.5719 50.6767 94.7635 50.8683L95.7652 51.87L91.2931 56.3421C91.1023 56.5329 90.7929 56.5329 90.6021 56.3421L89.9445 55.6845C89.7537 55.4937 89.7537 55.1843 89.9445 54.9935Z",
    fill: "#00A9E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.8736 84.4259C22.1379 83.7187 21.1609 83.3194 20.1379 83.3194C19.4483 83.2966 18.908 82.7377 18.908 82.0533V80.7871H15.092V82.0761C15.092 82.7377 14.5747 83.2852 13.908 83.3308C11.5402 83.4905 10 85.1217 10 87.1065V99.7339C10 100.43 10.5747 101 11.2759 101H22.7241C23.4253 101 24 100.43 24 99.7339V87.1065C24 86.1027 23.5977 85.1331 22.8736 84.4259Z",
    fill: "#E38A43"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 88.3613H20.1839V97.2016H10V88.3613Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.1839 78.2662V80.7871H13.8161V78.2662C13.8161 77.5703 14.3908 77 15.0919 77H18.908C19.6092 77 20.1839 77.5703 20.1839 78.2662Z",
    fill: "#E57200"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.6322 90.2661H11.908C11.5517 90.2661 11.2758 90.5513 11.2758 90.8935C11.2758 91.2471 11.5632 91.5209 11.908 91.5209H17.6322C17.9885 91.5209 18.2644 91.2357 18.2644 90.8935C18.2758 90.5399 17.9885 90.2661 17.6322 90.2661Z",
    fill: "#002F6C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.0919 92.7871H11.908C11.5517 92.7871 11.2758 93.0723 11.2758 93.4145C11.2758 93.7681 11.5632 94.0419 11.908 94.0419H15.0919C15.4483 94.0419 15.7241 93.7567 15.7241 93.4145C15.7241 93.0723 15.4368 92.7871 15.0919 92.7871Z",
    fill: "#002F6C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.8736 84.4259C47.1379 83.7187 46.1609 83.3194 45.1379 83.3194C44.4483 83.2966 43.908 82.7377 43.908 82.0533V80.7871H40.092V82.0761C40.092 82.7377 39.5747 83.2852 38.908 83.3308C36.5402 83.4905 35 85.1217 35 87.1065V99.7339C35 100.43 35.5747 101 36.2759 101H47.7241C48.4253 101 49 100.43 49 99.7339V87.1065C49 86.1027 48.5977 85.1331 47.8736 84.4259Z",
    fill: "#E38A43"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35 88.3613H45.1839V97.2016H35V88.3613Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.1839 78.2662V80.7871H38.8161V78.2662C38.8161 77.5703 39.3908 77 40.0919 77H43.908C44.6092 77 45.1839 77.5703 45.1839 78.2662Z",
    fill: "#E57200"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.6322 90.2661H36.908C36.5517 90.2661 36.2758 90.5513 36.2758 90.8935C36.2758 91.2471 36.5632 91.5209 36.908 91.5209H42.6322C42.9885 91.5209 43.2644 91.2357 43.2644 90.8935C43.2758 90.5399 42.9885 90.2661 42.6322 90.2661Z",
    fill: "#002F6C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.0919 92.7871H36.908C36.5517 92.7871 36.2758 93.0723 36.2758 93.4145C36.2758 93.7681 36.5632 94.0419 36.908 94.0419H40.0919C40.4483 94.0419 40.7241 93.7567 40.7241 93.4145C40.7241 93.0723 40.4368 92.7871 40.0919 92.7871Z",
    fill: "#002F6C"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrescribedMedication);
export default __webpack_public_path__ + "static/media/PrescribedMedication.8a2820b8c8ea7ce18d6ed3e0be9d5f36.svg";
export { ForwardRef as ReactComponent };